import {ISavedPromptData} from "../types/savedPrompt";
import apiUtil from "@/util/apiUtil";

const URL = "/api/SavedPrompts";

const savedPromptsAPI = {
    async savePrompt(promptText: string): Promise<ISavedPromptData> {
        const request = {
            promptText: promptText
        };
        return apiUtil.postData(URL, request);
    },

    async unsavePrompt(promptId: number): Promise<void> {
        return apiUtil.deleteData(`${URL}/${promptId}`);
    },

    async updatePrompt(
        promptId: number,
        promptText: string
    ): Promise<ISavedPromptData> {
        const request = {
            promptText: promptText
        };
        return apiUtil.putData(`${URL}/${promptId}`, request);
    },

    async getSavedPrompts(): Promise<ISavedPromptData[]> {
        return apiUtil.fetchData(URL);
    }
};

export default savedPromptsAPI;
